(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kz-hero"] && !Shopify.designMode) return;
  try {
    
function startKenzaHero(root) {
  root.querySelectorAll('.kz-hero__media video').forEach((video) => {
    if (video.dataset.autoplayReady) return;
    video.dataset.autoplayReady = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    const play = () => {
      if (!document.hidden && video.paused) video.play().catch(() => {});
    };
    video.addEventListener('loadeddata', play);
    video.addEventListener('canplay', play);
    window.addEventListener('pageshow', play);
    document.addEventListener('visibilitychange', play);
    document.addEventListener('touchstart', play, {passive: true, once: true});
    document.addEventListener('click', play, {once: true});
    play();
  });
}
startKenzaHero(document);
document.addEventListener('shopify:section:load', (event) => startKenzaHero(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // KBL-APPLICATION-CLOUD-FILTER-V1: clickable application chips filter visible collection cards.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kbl-app-filter]');
    if (!button || !document.querySelector('.template-collection')) return;
    const collectionRoot = button.closest('results-list') || document.querySelector('results-list');
    if (!collectionRoot || !collectionRoot.querySelector('.product-grid__item')) return;
    const key = button.getAttribute('data-kbl-app-filter');
    const active = button.getAttribute('aria-pressed') === 'true';
    const nextKey = active ? '' : key;
    collectionRoot.querySelectorAll('.kbl-redlight-group-divider').forEach((divider) => { divider.hidden = Boolean(nextKey); });
    collectionRoot.querySelectorAll('[data-kbl-app-filter]').forEach((chip) => {
      chip.setAttribute('aria-pressed', String(Boolean(nextKey && chip.getAttribute('data-kbl-app-filter') === nextKey)));
    });
    collectionRoot.querySelectorAll('.product-grid__item').forEach((card) => {
      const cardChip = card.querySelector('[data-kbl-app-filter]');
      card.hidden = Boolean(nextKey && (!cardChip || cardChip.getAttribute('data-kbl-app-filter') !== nextKey));
    });
    let reset = collectionRoot.querySelector('[data-kbl-app-reset]');
    if (!reset && nextKey) {
      reset = document.createElement('button');
      reset.type = 'button';
      reset.className = 'kbl-application-cloud kbl-application-cloud--reset';
      reset.setAttribute('data-kbl-app-reset', '');
      reset.textContent = 'Alle toepassingen';
      reset.addEventListener('click', () => {
        collectionRoot.querySelectorAll('[data-kbl-app-filter]').forEach((chip) => chip.setAttribute('aria-pressed', 'false'));
        collectionRoot.querySelectorAll('.product-grid__item').forEach((card) => { card.hidden = false; });
        collectionRoot.querySelectorAll('.kbl-redlight-group-divider').forEach((divider) => { divider.hidden = false; });
        reset.remove();
      });
      const grid = collectionRoot.querySelector('.product-grid');
      if (grid?.parentElement) grid.parentElement.insertBefore(reset, grid);
    } else if (reset && !nextKey) {
      reset.remove();
    }
  });


  } catch(e) { console.error(e); }
})();
})();
